import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
  Box,
  Drawer,
  DrawerCloseButton,
  DrawerContent,
  DrawerHeader,
  Text
} from '@qcx/ui';
import { Link } from '../Link';
import { QcMenu } from './QcMenu';
import { useCallback } from 'react';
import { useShellStore } from './shell.store';

export const NavMenu = () => {
  const menuItems = useShellStore(s => s.menuItems);
  const isMenuOpen = useShellStore(s => s.isMenuOpen);
  const toggleMenu = useShellStore(s => s.toggleMenu);

  const handleClose = useCallback(() => {
    toggleMenu(false);
  }, [toggleMenu]);

  return (
    <Drawer open={isMenuOpen} onOpenChange={toggleMenu}>
      <DrawerContent css={{ p: 0 }} side="left">
        <DrawerHeader>
          <DrawerCloseButton />
        </DrawerHeader>
        <Accordion css={{ flex: 1, border: 'none' }} type="single">
          {menuItems.map((item, i) => (
            <AccordionItem
              key={item.id ?? i}
              css={{
                border: 'none'
              }}
              value={item.id ?? ''}
            >
              <Box
                as={item.children ? 'div' : Link}
                to={item.children ? undefined : item.href}
                onClick={
                  item.children
                    ? undefined
                    : // eslint-disable-next-line @typescript-eslint/no-explicit-any
                      (e: any) => {
                        handleClose();
                        item.props?.onClick?.(e);
                      }
                }
              >
                <AccordionTrigger hideIcon={!item.children}>
                  <Box>{item.title}</Box>
                </AccordionTrigger>
              </Box>
              {item.children && (
                <AccordionContent>
                  {item.children.map(child => (
                    <Text
                      key={child.id}
                      as={child.href ? Link : 'span'}
                      css={{
                        color: '$textMuted',
                        d: 'flex',
                        py: '$4',
                        pl: '$10',
                        pr: '$4'
                      }}
                      to={child.href}
                      variant="md"
                      weight="semibold"
                    >
                      {child.title}
                    </Text>
                  ))}
                </AccordionContent>
              )}
            </AccordionItem>
          ))}
        </Accordion>
        <QcMenu />
      </DrawerContent>
    </Drawer>
  );
};
